export enum SolanaWeb3Network {
  DEVNET = "devnet",
  TESTNET = "testnet",
  MAINNET = "mainnet-beta",
}
